import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Modal, Text } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
import { getDetailOrder } from '../../../../services/orders'
import { deletePayment } from '../../../../services/payment'
import { useParams } from 'react-router-dom'
import NoData from '../../../ui/NoData'
import LoadingData from '../../../ui/LoadingData'
import OrderPaymentHistoryTable from './LayoutHelper/OrderPaymentHistoryTable'
import FormAdjustPaymentHistory from './Form/FormAdjustPaymentHistory'
import { modalDeleteData } from '../../../ui/Prompt/modalDeleteData'
import { getListUsers } from '../../../../services/users'

const labelTable = [
  {
    label: 'Payment ID',
    width: 'auto'
  },
  {
    label: 'Type',
    width: 'auto'
  },
  {
    label: 'Payment Method',
    width: 'auto'
  },
  {
    label: 'Date Received',
    width: 'auto'
  },
  {
    label: 'Payment Amount',
    width: 'auto'
  },
  {
    label: 'Note',
    width: 'auto'
  },
  {
    label: 'Created By',
    width: 'auto'
  },
  {
    label: 'Updated By',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]

const OrderPaymentHistory = () => {
  const params = useParams()
  const orderId = params.order_id
  const [loading, setLoading] = useState(true)
  const [paymentHistoryList, setPaymentHistoryList] = useState([])
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const handleGetDataPaymentOrder = async () => {
    setLoading(true)
    const params = {
      include:'payments,creator,updater'
    }
    try {
      const response = await getDetailOrder(orderId, params)
      if (response.success) {
        const resPayment = Object.values(response.included.payments)

        const remapDataPayment = await Promise.all(resPayment.map(async (val) => {
            const dataCreator = val.attributes.created_by ? await handleGetDataUser(val.attributes.created_by) : null
            const dataUpdater = val.attributes.updated_by ? await handleGetDataUser(val.attributes.updated_by) : null

            return {
              ...val.attributes,
              creator: dataCreator,
              updater: dataUpdater
            }
        }))

        setPaymentHistoryList(remapDataPayment)
      } else {
        setPaymentHistoryList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handleGetDataUser = async (userId) => {
    let dataUser = {}
    const params = {
      'filter[id][is]': userId,
      'fields[user]': 'id,name',
    }
    try {
      const response = await getListUsers(params)
      if (response.data.success) {
        dataUser = {
          id: response.data.data[0].attributes.id,
          name: response.data.data[0].attributes.name
        }
      }
      return dataUser
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    handleGetDataPaymentOrder()
    // eslint-disable-next-line
  }, [])

  const actions = {
    edit: (val) => {
      setOpenModalForm(true)
      setDetailData(val)
    },
    delete: (val) => {
      modalDeleteData('Payment History', val.id, val.label, deletePayment, handleGetDataPaymentOrder)
    },
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseFormOrderPaymentHistory = () => {
    setOpenModalForm(false)
    setDetailData(null)
  }
  
  return (
    <Box>
      <Box my={20}>
        <Box>
          <Flex justify='flex-end' align='center' my={20}>
            <Group align='center'>
              <Button size='xs' radius='sm' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add Payment</Button>
            </Group>
          </Flex>
        </Box>
        <Box my={30}>
          {loading ? <LoadingData /> : paymentHistoryList.length > 0 ? < OrderPaymentHistoryTable label={labelTable} data={paymentHistoryList} actionMethod={handleAction} /> : <NoData />}
        </Box>
      </Box>
      <Modal opened={openModalForm} onClose={onCloseFormOrderPaymentHistory} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>{detailData === null ? 'Add' : 'Update'} Payment History</Text>} withCloseButton={false}>
        <FormAdjustPaymentHistory dataPayment={detailData} onCloseForm={onCloseFormOrderPaymentHistory} reloadList={handleGetDataPaymentOrder} />
      </Modal>
    </Box>
  )
}

export default OrderPaymentHistory